// interface for column strategies
import HTMLColumnsStrategy from '../HTMLColumnsStrategy'

export default function BaseHTMLColumnStrategy() {}

BaseHTMLColumnStrategy.prototype = new HTMLColumnsStrategy();

BaseHTMLColumnStrategy.prototype.init = function ( timeformat ) {
    HTMLColumnsStrategy.prototype.init.call(this, timeformat);

    return this;
};

BaseHTMLColumnStrategy.prototype.getLevelsNumber = function () {
    // abstract
};

BaseHTMLColumnStrategy.prototype.addFirstHeaderRowCells = function ( row, levelsNumber ) {
    // abstract
};

BaseHTMLColumnStrategy.prototype.addSecondHeaderRowCells = function ( row, levelsNumber ) {
    // abstract
};

BaseHTMLColumnStrategy.prototype.addColumnValueCells = function ( row ) {
    // abstract
};




// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BaseHTMLColumnStrategy.js